import axios from 'axios';
import {SV_API_BASE_URL, SV_API_KEY} from '../config/api_endpoint'

const axiosInstance  = axios.create({
    baseURL: SV_API_BASE_URL,
});


const httpApiKeyHeader = (header = {}) => {
    let headers = {
        'Content-Type': 'application/json',
        'ApiKey': SV_API_KEY,
        ...header
    };
    return headers;
}


export const doPost = (url, data, header = {}) => {
    const config = {
        method: 'POST',
        url,
        data,
        headers: httpApiKeyHeader(header)
    };

    return axiosInstance(config)
        .then(function (response) {
            return response.data;
        }).catch((error) => {
            throw error
        })
}